import { IsNumber, IsOptional, IsString } from 'class-validator';

export class LocationDto {
    @IsString()
    id?: string;

    @IsString()
    @IsOptional()
    geo?: string;

    @IsString()
    @IsOptional()
    name?: string;

    @IsString()
    @IsOptional()
    country?: string;

    @IsString()
    @IsOptional()
    location_type?: string;

    @IsString()
    @IsOptional()
    region?: string;

    @IsString()
    @IsOptional()
    locality?: string;

    @IsString()
    @IsOptional()
    continent?: string;

    @IsString()
    @IsOptional()
    subregion?: string;

    @IsNumber()
    @IsOptional()
    population?: number;
}
